import axios from 'axios';
import store from '../redux/store';
import {serverWithoutProtocol} from '../config';

const AxiosServer =function(){
	//AxiosServer 这里是一个函数，不是class。不可以New。
	//也可以定义成一个class，通过new 来创建。但推荐用函数，因为传参方便。如果比较复杂的axios调用，函数较为方便。
	let {appReducer:app} =store.getState();	
	
	//从浏览器内存中获取token。
	if (sessionStorage.getItem('token')){
		axios.defaults.headers['token'] =sessionStorage.getItem('token');
	}		

	//防止有些浏览器兼容性问题导致数据丢失，再次从store中去读一次，如果有始终就最新的token去获取
	if (app.token !==''){
		axios.defaults.headers['token'] =app.token;
	}
	let isHttps = 'https:' === document.location.protocol ? true : false;

	if (isHttps) {
		axios.defaults.baseURL ='https://' + serverWithoutProtocol.path;
	}else{
		axios.defaults.baseURL ='http://' +serverWithoutProtocol.path;
	}

	axios.defaults.timeout = 30000;
	
	return axios;
}


const AxiosEsb=function(){
	//AxiosServer 这里是一个函数，不是class。不可以New。
	//也可以定义成一个class，通过new 来创建。但推荐用函数，因为传参方便。如果比较复杂的axios调用，函数较为方便。
	let {appReducer:app} =store.getState();	
	
	//从浏览器内存中获取token。
	if (sessionStorage.getItem('token')){
		axios.defaults.headers['token'] =sessionStorage.getItem('token');
	}		

	//防止有些浏览器兼容性问题导致数据丢失，再次从store中去读一次，如果有始终就最新的token去获取
	if (app.token !==''){
		axios.defaults.headers['token'] =app.token;
	}
	let isHttps = 'https:' === document.location.protocol ? true : false;

	if (isHttps) {
		axios.defaults.baseURL ='https://' + serverWithoutProtocol.esbPath;
	}else{
		axios.defaults.baseURL = 'http://' +serverWithoutProtocol.esbPath;
	}
	axios.defaults.timeout = 30000;
	
	return axios;
}

export {AxiosServer,AxiosEsb}
